<div class="loader" *ngIf="isLoading"></div>
<div class="content" *ngIf="!isLoading">

  <div class="thresholds-list">
    <threshold-widget [threshold]="thresholds" (updateThresholdEvent)="thresholdChanged($event)"></threshold-widget>
  </div>
</div>
